module.exports = __webpack_public_path__ + "a49393f2171a2f4d6927ce6c14f73dbc.woff2";